// src/events/trade/register.ts
import { EventCategory } from "@/domain/event";
import { registerEvent } from "@/event-core/registry";
import Detail from "./Detail";
import { cryptoViewModelProvider } from "./provider";
import { CryptoEventSkeleton } from "./Skeleton";
export const CryptoRegister = () => {
    registerEvent( EventCategory.Crypto, {
        getViewModel: cryptoViewModelProvider,
        Component: Detail,
        Skeleton: CryptoEventSkeleton,
    } );
};
